var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicPodcast = function SvgMicPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#999AA1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11 7.375a5 5 0 0 1-5 5m0 0a5 5 0 0 1-5-5m5 5V15.5m0 0H2.875M6 15.5h3.125M6 9.875a2.5 2.5 0 0 1-2.5-2.5V3.5a2.5 2.5 0 0 1 5 0v3.875a2.5 2.5 0 0 1-2.5 2.5Z"
  })));
};
export default SvgMicPodcast;